<template>
  <div id="app" class="device">
    <div class="device-wrap">
      <div class="device-title">推荐装置</div>
      <div class="device-box-wrap" id="device_whole_page_info">
        <div class="device-text">
          <p>「弹射世界」建议在下列装置上进行游戏。</p>
          <p>我们无法保证能于未列出的装置上运行，还请注意。</p>
          <br />
          <p>未来我们将随时针对新发售的装置进行运作确认，并更新至以下列表。</p>
        </div>
        <div class="device-box">
          <div class="device-box__title">【iOS版】</div>
          <div class="device-box__text">
            <span>系统需求：iOS 10.0以上的版本</span>
          </div>
          <div class="device-table">
            <div class="device-table__title">Apple</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">平板电脑</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>iPhone 12 Pro Max</td>
                  <td>iPad Pro 12.9 吋（第 4 代）</td>
                </tr>
                <tr>
                  <td>iPhone 12 Pro</td>
                  <td>iPad Pro 12.9 吋（第 3 代）</td>
                </tr>
                <tr>
                  <td>iPhone 12</td>
                  <td>iPad Pro 12.9 吋（第 2 代）</td>
                </tr>
                <tr>
                  <td>iPhone 12 mini</td>
                  <td>iPad Pro 11 吋（第 2 代）</td>
                </tr>
                <tr>
                  <td>iPhone 11 Pro Max</td>
                  <td>iPad Pro 11 吋（第 1 代）</td>
                </tr>
                <tr>
                  <td>iPhone 11 Pro</td>
                  <td>ipad Air（第 4 代）</td>
                </tr>
                <tr>
                  <td>iPhone 11</td>
                  <td>ipad Air（第 3 代）</td>
                </tr>
                <tr>
                  <td>iPhone SE（第 2 代）</td>
                  <td>iPad （第 8 代）</td>
                </tr>
                <tr>
                  <td>iPhone XS Max</td>
                  <td>iPad （第 7 代）</td>
                </tr>
                <tr>
                  <td>iPhone XS</td>
                  <td>iPad mini （第 5 代）</td>
                </tr>
                <tr>
                  <td>iPhone XR</td>
                  <td></td>
                </tr>
                <tr>
                  <td>iPhone X</td>
                  <td></td>
                </tr>
                <tr>
                  <td>iPhone 8 Plus</td>
                  <td></td>
                </tr>
                <tr>
                  <td>iPhone 8</td>
                  <td></td>
                </tr>
                <tr>
                  <td>iPhone 7 Plus</td>
                  <td></td>
                </tr>
                <tr>
                  <td>iPhone 7</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-box__text">
            <span> ■本程式不支援「家人共享」中的「询问购买」部分功能。</span>
            <span
              >此外，在已设定
              「家人共享」的装置上，使用「询问购买」功能进行消费时，可能发生无法正常消费的状况，请避免使用「询问购买」功能进行消费。</span
            >
          </div>
        </div>
        <div class="device-box">
          <div class="device-box__title">【Google Play版】</div>
          <div class="device-box__text">
            <span>系统需求：Android 5.0以上的版本</span>
          </div>
          <div class="device-table">
            <div class="device-table__title">Google Pixel</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">智慧型手机</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>Google Pixel 4a 5G</td>
                  <td>Google Pixel 4</td>
                </tr>
                <tr>
                  <td>Google Pixel 5</td>
                  <td>Google Pixel 3 XL</td>
                </tr>
                <tr>
                  <td>Google Pixel 4a</td>
                  <td>Google Pixel 3</td>
                </tr>
                <tr>
                  <td>Google Pixel 4 XL</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-table">
            <div class="device-table__title">Samsung</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">平板电脑</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>SAMSUNG Galaxy Z Fold2</td>
                  <td>SAMSUNG Galaxy Tab S7+ Wi-Fi</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Z Flip 5G</td>
                  <td>SAMSUNG Galaxy Tab S7+ 5G</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Z Flip</td>
                  <td>SAMSUNG Galaxy Tab S7</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S20+ 5G</td>
                  <td>SAMSUNG Galaxy Tab S6 LTE</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S20 Ultra 5G</td>
                  <td>SAMSUNG Galaxy Tab S6 Lite Wi-Fi</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S20 FE</td>
                  <td>SAMSUNG Galaxy Tab S6 Lite LTE</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S20 5G</td>
                  <td>SAMSUNG Galaxy Tab S6</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S10+</td>
                  <td>SAMSUNG Galaxy Tab S5e</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S10</td>
                  <td>SAMSUNG Galaxy Tab A7 Wi-Fi</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S9+</td>
                  <td>SAMSUNG Galaxy Tab A7 LTE</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S9</td>
                  <td>SAMSUNG Galaxy Tab A 8.0 （2019）</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S8+</td>
                  <td>SAMSUNG Galaxy Tab A 10.5 Wi-Fi</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy S8</td>
                  <td>SAMSUNG Galaxy Tab A 10.5 LTE</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Note 20 Ultra</td>
                  <td>SAMSUNG Galaxy Tab A 10.1 （2019）</td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Note 20</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Note 10+</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Note 10 Lite</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Note 10</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Note 9</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy Note 8</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy M11</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A9 (2018）</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A71 5G</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A71</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A51 5G</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A51</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A42 5G</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A31</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A30s</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A21s</td>
                  <td></td>
                </tr>
                <tr>
                  <td>SAMSUNG Galaxy A20</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-table">
            <div class="device-table__title">OPPO</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">智慧型手机</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>OPPO A73 5G</td>
                  <td>OPPO Find X2 Pro</td>
                </tr>
                <tr>
                  <td>OPPO A53</td>
                  <td>OPPO Find X2</td>
                </tr>
                <tr>
                  <td>OPPO Reno4 Z</td>
                  <td>OPPO A91</td>
                </tr>
                <tr>
                  <td>OPPO Reno4</td>
                  <td>OPPO A72</td>
                </tr>
                <tr>
                  <td>OPPO Reno4 Pro</td>
                  <td>OPPO A31 2020</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-table">
            <div class="device-table__title">SONY</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">智慧型手机</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>Sony Xperia 1 II</td>
                  <td>Sony Xperia XZ3</td>
                </tr>
                <tr>
                  <td>Sony Xperia 5 II</td>
                  <td>Sony Xperia XZ2 Premium</td>
                </tr>
                <tr>
                  <td>Sony Xperia 10 II</td>
                  <td>Sony Xperia XZ2 Compact</td>
                </tr>
                <tr>
                  <td>Sony Xperia 5</td>
                  <td>Sony Xperia XZ1</td>
                </tr>
                <tr>
                  <td>Sony Xperia 1</td>
                  <td>Sony Xperia XZ1 Compact</td>
                </tr>
                <tr>
                  <td>Sony Xperia L3</td>
                  <td>Sony Xperia XZ Premium</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-table">
            <div class="device-table__title">HUAWEI</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">平板电脑</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>HUAWEI Mate 20 X 5G</td>
                  <td>HUAWEI MediaPad M6 10.8</td>
                </tr>
                <tr>
                  <td>HUAWEI Y9 Prime 2019</td>
                  <td>HUAWEI MediaPad T5</td>
                </tr>
                <tr>
                  <td>HUAWEI Mate 20 Pro</td>
                  <td>HUAWEI MediaPad M5 Lite</td>
                </tr>
                <tr>
                  <td>HUAWEI Y9 2019</td>
                  <td>HUAWEI MediaPad T3 10</td>
                </tr>
                <tr>
                  <td>HUAWEI P30 Pro</td>
                  <td>HUAWEI MediaPad M5 10.8</td>
                </tr>
                <tr>
                  <td>HUAWEI P20</td>
                  <td>HUAWEI MediaPad M5 8.4</td>
                </tr>
                <tr>
                  <td>HUAWEI Mate 10</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-table">
            <div class="device-table__title">ASUS</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">平板电脑</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>ASUS ZenFone 7 ZS670KS</td>
                  <td>ASUS Chromebook Tablet CT100</td>
                </tr>
                <tr>
                  <td>ASUS ZenFone 7 Pro ZS671KS</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone 7 ZS670KS</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ROG Phone 3 ZS661KS</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone Max Pro M2 ZB631KL</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone Max Pro 2019 ZB602KL</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone 6 Edition 30 ZS630KL</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone 6 ZS630KL</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone Max M2 ZB633KL</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone Max Pro M2 ZB631KL</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ASUS ZenFone Max Pro ZB602KL</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-table">
            <div class="device-table__title">HTC</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">智慧型手机</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>HTC Desire 20+</td>
                  <td>HTC U11</td>
                </tr>
                <tr>
                  <td>HTC U20 5G</td>
                  <td>HTC Desire 19+</td>
                </tr>
                <tr>
                  <td>HTC Desire 20 pro</td>
                  <td>HTC U12+</td>
                </tr>
                <tr>
                  <td>HTC EXODUS 1-Binance</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="device-table">
            <div class="device-table__title">小米</div>
            <table class="device-table__table">
              <thead class="device-table__thead">
                <tr>
                  <th class="device-table__th">智慧型手机</th>
                  <th class="device-table__th">智慧型手机</th>
                </tr>
              </thead>
              <tbody class="device-table__tbody">
                <tr>
                  <td>红米 Note 9 Pro</td>
                  <td>小米 10 Lite</td>
                </tr>
                <tr>
                  <td>小米 10 Lite 128GB</td>
                  <td>红米 Note 8T</td>
                </tr>
                <tr>
                  <td>红米 Note 9</td>
                  <td>小米 9T</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Device",
  components: {},
  data() {
    return {};
  },
  computed: mapGetters(["initData"]),
  watch: {
    initData(e) {
      if (!e.frament.length) return;
      let that = this;
      e.frament.map(e => {
        const __content = that
          .$("<div>")
          .html(e.content)
          .text();
        if (e.position === "recommend_equipment") {
          that.$("#device_whole_page_info").html(__content);
        }
      });
    }
  },
  mounted: function() {
    window.$("#LT_age").remove();
    const that = this;
    that.initData2(that.initData);
  },
  methods: {
    initData2(e) {
      if (!e.frament.length) return;
      let that = this;
      e.frament.map(e => {
        const __content = that
          .$("<div>")
          .html(e.content)
          .text();
        if (e.position === "recommend_equipment") {
          that.$("#device_whole_page_info").html(__content);
        }
      });
    }
  }
};
</script>
<style scoped></style>
